export default __webpack_public_path__ + "static/media/error404.9ac762e5.jpg";